module.exports = __webpack_public_path__ + "ug.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ug.svg
// module id = 1118
// module chunks = 0